import virtualDataTransformation from '../../jsons/virtual-data-transformation';

export var mapToVirtualValue = function mapToVirtualValue(key, value) {
    // console.log(virtualDataTransformation, virtualDataTransformation['bancos'])
    return (virtualDataTransformation[key] || {})[value];
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/virtual-transform-data.js
// module id = ./src/mappers/virtual-transform-data.js
// module chunks = 34